export default __webpack_public_path__ + "media/zurb/img/party/55n3rd-fdd50fd6d75d3cae315fa9183882e032.png";